import { AppBar } from "@mui/material";
import TopToolbar from "./TopToolbar";
import SubMenuToolbar from "./SubMenuToolbar";
import theme from "../styles/themes/theme";

const AppBarComponent = ({ canvas }) => {
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: "100%",
          zIndex: 1200,
          backgroundColor: "white",
          color: "black",
          boxShadow: theme.shadows[2],
          py: { xs: theme.spacing(0.5), sm: theme.spacing(1) },
          mb: {
            xs: theme.spacing(1),
            sm: theme.spacing(2),
            md: theme.spacing(3),
          },
        }}
      >
        <TopToolbar />
        <SubMenuToolbar />
      </AppBar>
    </>
  );
};

export default AppBarComponent;
